import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledContainer = styled(CenteredFlexColumn)`
    row-gap: 12px;
    padding: 24px;
`;

export const StyledImage = styled.img`
    display: block;
    height: auto;
    width: 170px;
`;

export const StyledImageWrapper = styled.div`
    min-height: 170px;
`;

export const StyledTextWrapper = styled(CenteredFlexColumn)``;

export const StyledTitle = styled.h1`
    ${mixins.setFontVariant("subtitle1", colorsPalettes.carbon[500])};

    margin: 0;
    text-align: center;
`;

export const StyledSubtitle = styled.p`
    ${mixins.setFontVariant("caption", colorsPalettes.carbon[300])};
    margin: 4px 0 16px;
`;
